import ConsultantNewDTO from '@src/adapters/dto/consultant/ConsultantNewDTO';
import useApi, { ApiOptions } from '../base/useApi';
import ConsultantDTO from '@src/adapters/dto/consultant/ConsultantDTO';
interface Params {
  consultant: ConsultantNewDTO;
}

interface Result {
  consultant: ConsultantDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/consultant/create',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useCreateConsultantLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useCreateConsultantLazy;
